import { type FC, useState, useCallback, useEffect } from 'react';

import { SbSharedFavoritesNudgeToastWatcher } from './SbSharedFavoritesNudgeToastWatcher';
import { canDisplayFavoritesNudge } from '../helpers/canDisplayFavoritesNudge';
import { trackItemFavoritingFeb2026Test } from 'dibs-buyer-item-favoriting/src/abTests';

type Props = {
    userId: string;
    isItemFavoritingVariant: boolean;
    isItemFavoritingFeb2026Variant?: boolean;
    isItemFavoritingFeb2026Control?: boolean;
};

const SbSharedFavoritesNudgeToast: FC<Props> = ({
    userId,
    isItemFavoritingVariant,
    isItemFavoritingFeb2026Variant,
    isItemFavoritingFeb2026Control,
}) => {
    const [startWatch, setStartWatch] = useState(false);

    const handleStopWatch = useCallback(() => {
        setStartWatch(false);
    }, []);

    useEffect(() => {
        if (isItemFavoritingFeb2026Control && canDisplayFavoritesNudge()) {
            trackItemFavoritingFeb2026Test();
        }

        // Show for Nov2025 test OR desktop test (desktop only)
        const shouldShowNudge = isItemFavoritingVariant || isItemFavoritingFeb2026Variant;

        if (shouldShowNudge) {
            setStartWatch(true);
        }
    }, [isItemFavoritingVariant, isItemFavoritingFeb2026Variant, isItemFavoritingFeb2026Control]);

    if (!startWatch) {
        return null;
    }

    return <SbSharedFavoritesNudgeToastWatcher userId={userId} onStopWatch={handleStopWatch} />;
};

export { SbSharedFavoritesNudgeToast };
